var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app pt-0",attrs:{"id":"app"}},[_c('vue-headful',{attrs:{"title":""}}),_c('navbar'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{staticClass:"m-0",staticStyle:{"padding-top":"14px !important"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }